import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Fieldset, Legend, Label,
    Name, Input
} from "reactstrap"
import { ConfirmAlert } from '../../../../../helpers/ui/alert'
import { accessRole } from '../../../../../helpers/access_role'
import Select from '../../../../../helpers/ui/CustomSelect'
import { Preview } from '../../../../../helpers/ui/FileInput'
import { AvForm } from "availity-reactstrap-validation"
import moment from 'moment';

import { Link, Redirect, withRouter } from "react-router-dom"

import apiResponse from '../../../../../services/apiResponse'
import { cancelToken } from '../../../../../services/adapters/kepegawaian/menuService'

import IndexBloc from '../Index/Blocs/IndexBloc'
import Shimmer from "react-shimmer-effect";

import { CreateComponent as CreateDinas } from '../../Dinas/Create/View'

class DetailView extends Component {

    source
    indexBloc = new IndexBloc()
    timer

    constructor(props) {
        super(props)
        this.state = {
            selectedCorrectionType: 2,
            domicile: 1,
            oversea: 1,
            options: [],
            detail: null
        }
    }

    loadDetail = async () => {
        const query = {
            uuid: this.props.uuid
        }
        await this.indexBloc.fetchDetail(query, this.source.token)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadDetail()
    }

    componentDidMount = () => {
        this.setTokenAPI()

        this.indexBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    console.log('cek', result.data.response)
                    const res = result.data.response
                    this.setState({
                        detail: result.data.response,
                        selectedCorrectionType: res.attendance_correction_type
                    })
                    break;
                default:
                    break;
            }
        })
    }

    render() {
        let { options, detail } = this.state;
        const correctionType = [
            { value: 2, label: 'Pribadi' },
            { value: 1, label: 'Dinas' },
        ]
        const adjustmentType = [
            { value: 1, label: 'Jam Masuk' },
            { value: 2, label: 'Jam Keluar' },
            { value: 3, label: 'Jam Masuk & Jam Keluar' },
        ]
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col md="12">
                            <Card>
                                <CardBody>
                                    <div className="float-end">
                                        <Link to='/izinpegawai/koreksikehadiran.html'>
                                            <Button outline color="primary"><i className="uil uil-backward"></i> Kembali</Button>
                                        </Link>
                                    </div>
                                    <CardTitle>Detail Koreksi Kehadiran</CardTitle>
                                    <CardSubtitle className="mb-3">
                                    </CardSubtitle>
                                    <hr />

                                    {/* <Row className="mb-3">
                                        <Label
                                            className="col-md-2 col-form-label"
                                        >
                                            Alasan Penyesuaian
                                        </Label>
                                        <Col md="4">
                                            <Select
                                                isAvForm={false}
                                                placeholder="Alasan Penyesuaian"
                                                errorMessage="Pilih Alasan Penyesuaian"
                                                className="form-control"
                                                validate={{ required: { value: true } }}
                                                onChange={opt => this.setState({ selectedCorrectionType: opt.value })}
                                                options={correctionType}
                                                isSearchable={false}
                                                isDisabled={true}
                                                defaultValue={this.state.selectedCorrectionType}
                                            />                                            
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <Label
                                            className="col-md-2 col-form-label"
                                        >
                                            Kehadiran yang disesuaikan
                                        </Label>
                                        <Col md="4">
                                            <Select
                                                isAvForm={false}
                                                placeholder="Kehadiran yang disesuaikan"
                                                errorMessage="Pilih Kehadiran yang disesuaikan"
                                                className="form-control"
                                                validate={{ required: { value: true } }}
                                                options={adjustmentType}
                                                isSearchable={false}
                                                isDisabled={true}
                                                defaultValue={detail?.attendance_correction_adjustment_type}
                                            />                                            
                                        </Col>
                                    </Row>

                                            <Row className="mb-3">
                                                <Label
                                                    className="col-md-2 col-form-label"
                                                >
                                                    Tanggal Surat / Dokumen Izin 
                                                </Label>
                                                <Col md="4">
                                                    <Input
                                                        value={detail?.attendance_correction_document_date}
                                                        name="attendance_correction_document_date"
                                                        placeholder="Tanggal Surat / Dokumen Izin"
                                                        type="date"
                                                        errorMessage="Masukkan Tanggal Surat / Dokumen Izin"
                                                        className="form-control"
                                                        disabled={true}
                                                        validate={{ required: { value: true } }}
                                                    />
                                                </Col>
                                            </Row>

                                            <Row className="mb-3">
                                                <Label
                                                    className="col-md-2 col-form-label"
                                                >
                                                    Alasan Izin 
                                                </Label>
                                                <Col md="4">
                                                    <Input
                                                        value={detail?.attendance_correction_note}
                                                        name="attendance_correction_note"
                                                        placeholder="Alasan Izin"
                                                        type="textarea"
                                                        rows="4"
                                                        errorMessage="Masukkan Alasan Izin"
                                                        className="form-control"
                                                        disabled={true}
                                                        validate={{ required: { value: true } }}
                                                    />
                                                </Col>
                                            </Row>

                                            <Row className="mb-3">
                                                <Label
                                                    className="col-md-2 col-form-label"
                                                >
                                                    Tanggal Pelaksanaan Izin 
                                                </Label>
                                                <Col md="4">
                                                    <Input
                                                        value={detail?.attendance_correction_date}
                                                        name="attendance_correction_date"
                                                        placeholder="Tanggal Pelaksanaan Izin"
                                                        type="date"
                                                        errorMessage="Masukkan Tanggal Pelaksanaan Izin"
                                                        className="form-control"
                                                        disabled={true}
                                                        validate={{ required: { value: true } }}
                                                    />
                                                </Col>
                                            </Row> */}

                                    <Row className="mb-3">
                                        <Label className="col-md-2 col-form-label">
                                            Kategori Alasan
                                        </Label>
                                        <Col md="4">
                                            <Input
                                                value={detail?.correction_type_categories_name || detail?.attendance_correction_note || ''}
                                                className="form-control"
                                                disabled={true}
                                            />
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <Label className="col-md-2 col-form-label">
                                            Tanggal Koreksi
                                        </Label>
                                        <Col md="4">
                                            <Input
                                                value={moment(detail?.attendance_correction_date).format("DD MMMM YYYY")}
                                                className="form-control"
                                                disabled={true}
                                            />
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <Label className="col-md-2 col-form-label">
                                            Jenis Koreksi
                                        </Label>
                                        <Col md="4">
                                            <Input
                                                value={detail?.correction_type_name || ''}
                                                className="form-control"
                                                disabled={true}
                                            />
                                        </Col>
                                    </Row>

                                    {detail?.attendance_correction_adjustment_type && (
                                        <Row className="mb-3">
                                            <Label className="col-md-2 col-form-label">
                                                Perbaikan Jam Cuti
                                            </Label>
                                            <Col md="4">
                                                <Input
                                                    value={detail?.attendance_correction_adjustment_type_name || ''}
                                                    className="form-control"
                                                    disabled={true}
                                                />
                                            </Col>
                                        </Row>
                                    )}

                                    {detail?.attendance_correction_letter_number && detail.attendance_correction_letter_number.length !== 0 && (
                                        <Row className="mb-3">
                                            <Label className="col-md-2 col-form-label">
                                                Nomor Surat Dinas
                                            </Label>
                                            <Col md="4">
                                                <Input
                                                    value={detail?.attendance_correction_letter_number}
                                                    className="form-control"
                                                    disabled={true}
                                                />
                                            </Col>
                                        </Row>
                                    )}

                                    <Row className="mb-3">
                                        <Label className="col-md-2 col-form-label">
                                            Dokumen Pendukung
                                        </Label>
                                        <Col md="4">
                                            <Preview col="12" value={detail?.document} />
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <Label className="col-md-2 col-form-label">
                                            Dokumen Permohonan
                                        </Label>
                                        <Col md="4">
                                            <Preview col="12" value={detail?.document_request} />
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <label className="col-md-2">
                                            Status
                                        </label>
                                        <Col md="9">
                                            {
                                                detail ?
                                                    <>
                                                        {
                                                            <label className={`badge rounded-pill ${((detail?.attendance_correction_approval_status == 1) ? 'bg-soft-success' : ((detail?.attendance_correction_approval_status == 2) ? 'bg-soft-danger' : 'bg-soft-warning'))} font-size-12`}>{((detail?.attendance_correction_approval_status == 1) ? 'Disetujui' : ((detail?.attendance_correction_approval_status == 2) ? 'Ditolak' : 'Menunggu Persetujuan'))}</label>

                                                        }
                                                    </>
                                                    : <Shimmer><div style={{ width: '50%', height: 15 }}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    {
                                        (detail && detail?.employee_wfh_status == 2) ?
                                            <Row className="mb-3">
                                                <label className="col-md-3">
                                                    Alasan Penolakan
                                                </label>
                                                <Col md="9">
                                                    {
                                                        detail ?
                                                            <>
                                                                {
                                                                    detail?.attendance_correction_description !== "" ?
                                                                        detail?.attendance_correction_description
                                                                        : '-'
                                                                }
                                                            </>
                                                            : <Shimmer><div style={{ width: '50%', height: 15 }}></div></Shimmer>
                                                    }
                                                </Col>
                                            </Row>
                                            : ''
                                    }
                                    {/* </Fragment>
                                    } */}

                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </Fragment>
        )
    }

}

export default DetailView;